import React from "react";
import styles from "./ArrowDivider.module.scss";
import SpawningArrow from "../../../public/assets/icons/SpawningArrow";

const ArrowDivider = () => {
  return (
    <div className={styles.divider}>
      <SpawningArrow className={styles.arrowLeftIcon} />
      <div className={styles.line} />
      <SpawningArrow className={styles.arrowRightIcon} />
    </div>
  );
};

export default ArrowDivider;
